export const NodataFallback = () => {
  return <span className="text-gray-200 group-hover:text-gray-400">Noch keine Daten</span>
}
